import { Text } from "@engaging-tech/components"
import React from "react"

import { CustomFlex } from "../../styles"

const titleText = [
  "World’s Happiest Workplaces",
  "Search the live list to find the World’s Happiest Workplaces, as rated by the employees that work there."
]

const AwardsIntroBanner = () => {
  return (
    <CustomFlex width={1} flexDirection="column" alignItems="center">
      <Text
        fontSize={[5, 7]}
        fontWeight={600}
        textAlign="center"
        color="primary.0"
        width="auto"
        fontFamily="Tiempos"
      >
        {titleText[0]}
      </Text>
      <Text fontSize={4} fontWeight={500} textAlign="center" color="dark.1" width="auto">
        {titleText[1]}
      </Text>
    </CustomFlex>
  )
}

export default AwardsIntroBanner
